import { LayoutModule } from '../../layout/modules';
import { TendersList } from './list';
import { useState } from 'react';
import { LICITACIONES_NEW } from '../../../routes/paths';
import { TenderFilters } from './filters';
import { TenderFilter } from '../../../shared/types/tender';

export const Tenders = () => {
    const [filters, setFilters] = useState<TenderFilter>();

    return (
        <>
            <LayoutModule title="Licitaciones" createPath={LICITACIONES_NEW}>
                <TenderFilters onFilter={(filters) => setFilters(filters)} />
            </LayoutModule>
            <TendersList filters={filters} />
        </>
    );
};
